<template>
    <div>
        <div class="grid-x grid-padding-x">
            <div class="cell auto">

                <slim-cropper
                  :options="slimOptions"
                >
				<input type="file">
               </slim-cropper>
               <input type="hidden" :name="fieldname" :value="uploadedFile">
            </div>
        </div>

    </div>
</template>

<script>
import Slim from "../vendor/slim/slim.vue";
import Cookies from "js-cookie";

export default {
  name: "slim-uploader",
  props: {
    fieldname: { required: true },
    label: {
      required: false,
      default: "Upload"
    },
    size: {
      required: false,
      default: false
    },
    service: {
      required: true
    },
    required: {
      required: false,
      default: false
    },
    image: {
      required: false
    },
    push: {
      required: false,
      default: false
    },
    ratio: {
      required: false,
      default: "free"
    }
  },
  methods: {
    afterRemove: function(error, data) {
      this.$emit("afterRemove");
    },
    afterUpload: function(error, data, response, slim) {
      slim._output.value = response.path;
      this.uploadedFile = response.path;
      this.$emit("afterUpload", response);
    },
    handleRequest: function(xhr) {
      let token = Cookies.get("csrfToken");
      if (token) {
        xhr.setRequestHeader("X-CSRF-Token", token);
      }
    }
  },
  computed: {},
  components: {
    "slim-cropper": Slim
  },
  data() {
    return {
      slimOptions: {
        ratio: "1:1",
        service: this.service,
        defaultInputName: 'slim',
        push: this.push,
        didUpload: this.afterUpload,
        didRemove: this.afterRemove,
        initialImage: this.image,
        ratio: this.ratio,
        willRequest: this.handleRequest
      },
      uploadedFile: null
    };
  }
};
</script>

<style>
.shrink img {
  max-height: 11rem;
}
</style>


// WEBPACK FOOTER //
// assets/js/vue/components/SlimUploader.vue